import React, { useCallback } from 'react'
import { withRef } from '@udecode/cn'
import { unwrapCodeBlock } from '@udecode/plate-code-block'
import { TPlateEditor } from '@udecode/plate-common/react'
import { BaseBulletedListPlugin, BaseNumberedListPlugin, toggleList } from '@udecode/plate-list'
import { useListToolbarButtonState } from '@udecode/plate-list/react'
import { BoxProps, IconButton, IconName } from '@ui'

import { isCodeBlockElement } from '../../utils/helpers'

type Props = {
    nodeType: typeof BaseBulletedListPlugin.key | typeof BaseNumberedListPlugin.key
    icon: IconName
    tooltip: React.ReactNode
    editor: TPlateEditor
    background?: BoxProps['background']
}

export const ListToolbarButton = withRef<
    React.FC<Props>,
    {
        nodeType?: Props['nodeType']
        background?: BoxProps['background']
    }
>(
    (
        { nodeType: _nodeType = BaseBulletedListPlugin.key, icon, tooltip, editor, background },
        ref,
    ) => {
        const { pressed } = useListToolbarButtonState({
            nodeType: _nodeType,
        })

        const onClick = useCallback(
            (e: React.MouseEvent) => {
                e.preventDefault()
                e.stopPropagation()
                if (isCodeBlockElement(editor)) {
                    unwrapCodeBlock(editor)
                }
                toggleList(editor, { type: _nodeType })
            },
            [_nodeType, editor],
        )

        return (
            <IconButton
                opaque
                active={pressed}
                icon={icon}
                background={pressed ? 'level3' : background}
                tooltip={tooltip}
                tooltipOptions={{ placement: 'vertical', immediate: true }}
                ref={ref}
                onClick={onClick}
                onMouseDown={onClick}
            />
        )
    },
)
